import {
  AbstractControl,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms'

export function validateAllFormFields(control: AbstractControl) {
  if (control instanceof UntypedFormGroup) {
    Object.keys(control.controls).forEach((field) => {
      validateAllFormFields(control.get(field))
    })
  } else if (control instanceof UntypedFormArray) {
    for (const c of control.controls) {
      validateAllFormFields(c)
    }
  } else if (control instanceof UntypedFormControl) {
  }
  control.updateValueAndValidity({ onlySelf: true, emitEvent: false })
  control.markAsDirty()
  control.markAsTouched()
}
